import { type ReactNode } from 'react';

// COUPLED: keep these classes byte-for-byte in sync with the real card
// (src/modules/team/components/team-member-parts.tsx GlassInfo/EditBtn).
// The overlay is a static mockup; if the real card paddings change here
// won't, the crop preview will lie about where the chip and glass land.

const CHIP_CLS =
  'absolute left-sm top-sm z-20 rounded-full bg-info/80 px-2 py-0.5 text-[9px] font-medium text-white shadow';

const COUNT_CLS =
  'absolute right-sm top-sm z-20 rounded-full bg-white/10 px-2 py-0.5 text-[9px] font-medium text-white/80 backdrop-blur-sm';

const GLASS_CLS =
  'absolute inset-x-0 bottom-0 z-20 bg-black/25 px-sm pb-xs pt-sm text-left backdrop-blur-sm';

const NAME_CLS = 'truncate text-sm font-semibold text-white';
const PHRASE_CLS =
  'mt-xs line-clamp-2 text-xs italic leading-snug text-white/80';
const EDIT_CLS =
  'mt-xs flex w-full items-center justify-center rounded-md bg-brand-red px-sm py-1.5 text-xs font-semibold text-white shadow-sm';

export function CropOverlay(): ReactNode {
  return (
    <>
      <span className={CHIP_CLS}>Verificando</span>
      <span className={COUNT_CLS}>0 creadores</span>
      <div className={GLASS_CLS}>
        <span className={NAME_CLS}>Tu nombre</span>
        <p className={PHRASE_CLS}>Aqui ira tu frase personal</p>
        <div className={EDIT_CLS}>Editar frase</div>
      </div>
    </>
  );
}
